import { getSession } from '../services/cognitoAuth';

export class ApiError extends Error {
  constructor(
    public readonly status: number,
    message: string,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

export async function fetchJson<T>(url: string, init?: RequestInit): Promise<T> {
  const tokens = await getSession();
  const resp = await fetch(url, {
    ...init,
    headers: {
      Authorization: `Bearer ${tokens.idToken}`,
      ...init?.headers,
    },
  });
  if (!resp.ok) {
    throw new ApiError(resp.status, await resp.text().catch(() => resp.statusText));
  }
  return resp.json() as Promise<T>;
}

/**
 * Like {@link fetchJson} but for endpoints that answer 204 No Content
 * (or any empty body). Throws {@link ApiError} on non-2xx, carrying the
 * server's body text as `.message` so callers can surface e.g. a 422
 * "No provider named '…'". Never parses JSON.
 */
export async function fetchNoContent(url: string, init?: RequestInit): Promise<void> {
  const tokens = await getSession();
  const resp = await fetch(url, {
    ...init,
    headers: {
      Authorization: `Bearer ${tokens.idToken}`,
      ...init?.headers,
    },
  });
  if (!resp.ok) {
    throw new ApiError(resp.status, await resp.text().catch(() => resp.statusText));
  }
}

export async function fetchMultipart<T>(url: string, body: FormData): Promise<T> {
  const tokens = await getSession();
  const resp = await fetch(url, {
    method: 'POST',
    headers: { Authorization: `Bearer ${tokens.idToken}` },
    body,
  });
  if (!resp.ok) {
    throw new ApiError(resp.status, await resp.text().catch(() => resp.statusText));
  }
  return resp.json() as Promise<T>;
}
